<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
    },
    data() {
        return {
            data: {},
            routeName: 'store',
        }
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            if (vm.$route.query.keyword)
                vm.data.keyword = vm.$route.query.keyword;

            if (vm.$route.query.user_id)
                vm.data.user_id = vm.$route.query.user_id;
        },
        newData() {
            var vm = this;

            var data = {
                keyword: null,
                user_id: null,
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;

            vm.success(vm.data);
            vm.$sidebar.hide();
        },
        fetchUser: async function (params) {
            const resp = await this.$api.User.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        }
    }
}
</script>

<template>
    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('filter.label.keyword') }}</label>
                        <input type="text" class="form-control" v-model="data.keyword" id="product-title-input"
                            :placeholder="$t('filter.placeholder.keyword')" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('store.label.user')
                            }}</label>
                        <dynamic-select v-model="data.user_id" :loadOptions="fetchUser"
                            :placeholder="$t('store.placeholder.user')" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="$ac.hasAccess('store_full_access') || $ac.hasAccess('store_list')">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="primary" class="w-100" @click="submit"
                                    :disabled="$loading.get([routeName, 'list'].join('_'))">
                                    <loading :loading="$loading.get([routeName, 'list'].join('_'))">
                                        <i class="mdi mdi-filter-outline me-1"></i>
                                        {{ $t('basic.btn.filter') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>